var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriversIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.548584C4.91193 0.548584 0.75 4.71051 0.75 9.79858C0.75 14.8867 4.91193 19.0486 10 19.0486C15.0881 19.0486 19.25 14.8867 19.25 9.79858C19.25 4.71051 15.0881 0.548584 10 0.548584ZM10 2.84858C12.5969 2.84858 14.9514 4.30295 16.1284 6.50791L12.2442 7.88356C11.6576 7.19368 10.828 6.84858 10 6.84858C9.18634 6.84858 8.35893 7.18313 7.84076 7.79646L3.87506 6.50153C5.05315 4.30015 7.40559 2.84858 10 2.84858ZM8.85 12.4929V16.6184C5.59504 16.0609 3.05 13.1726 3.05 9.79858C3.05 9.37962 3.10645 9.01971 3.17689 8.60353L7.05517 9.97709C7.12128 11.1143 7.81647 12.0763 8.85 12.4929ZM10 10.4486C9.78681 10.4486 9.62858 10.3786 9.52428 10.2743C9.41997 10.17 9.35 10.0118 9.35 9.79858C9.35 9.5854 9.41997 9.42717 9.52428 9.32286C9.62858 9.21856 9.78681 9.14858 10 9.14858C10.2132 9.14858 10.3714 9.21856 10.4757 9.32286C10.58 9.42717 10.65 9.5854 10.65 9.79858C10.65 10.0118 10.58 10.17 10.4757 10.2743C10.3714 10.3786 10.2132 10.4486 10 10.4486ZM12.9448 9.97709L16.8231 8.60353C16.8936 9.01971 16.95 9.37962 16.95 9.79858C16.95 13.2583 14.4067 16.0655 11.15 16.6186V12.4929C12.1835 12.0763 12.8787 11.1143 12.9448 9.97709Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversIcon);
export default __webpack_public_path__ + "static/media/drivers-icon.8b244a5f42f98cfb8bcf3789bce4e898.svg";
export { ForwardRef as ReactComponent };